import { render, staticRenderFns } from "./FolderGroupManager.vue?vue&type=template&id=6df86935&scoped=true"
import script from "./FolderGroupManager.vue?vue&type=script&lang=js"
export * from "./FolderGroupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df86935",
  null
  
)

export default component.exports